import MobileRecordCard from './MobileRecordCard';
import { formatTRY } from '@/lib/currencyFormat';

interface CustomerPaymentsTabProps {
  payments: any[];
}

export default function CustomerPaymentsTab({ payments }: CustomerPaymentsTabProps) {
  if (payments.length === 0) {
    return (
      <div className="p-5">
        <div className="flex flex-col items-center py-8 gap-2">
          <div className="w-12 h-12 rounded-2xl bg-background-100 flex items-center justify-center">
            <i className="ri-bank-card-line text-xl text-foreground-300"></i>
          </div>
          <p className="text-sm font-medium text-foreground-500">Henüz ödeme kaydı yok</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 lg:p-5">
      {/* Desktop table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead><tr className="border-b border-background-100"><th className="table-header">Tarih</th><th className="table-header">Satış No</th><th className="table-header">Tutar</th><th className="table-header">Yöntem</th><th className="table-header">Makbuz No</th><th className="table-header">Açıklama</th></tr></thead>
          <tbody>
            {payments.map(payment => (
              <tr key={payment.id} className="border-b border-background-100 hover:bg-background-50">
                <td className="table-cell">{payment.payment_date ? new Date(payment.payment_date).toLocaleDateString('tr-TR') : ''}</td>
                <td className="table-cell text-primary-600 font-medium">{payment.sale_no}</td>
                <td className="table-cell font-medium text-emerald-600">{formatTRY(payment.amount || 0)}</td>
                <td className="table-cell text-foreground-500">{payment.payment_method}</td>
                <td className="table-cell text-foreground-400 text-xs">{payment.receipt_no}</td>
                <td className="table-cell text-foreground-400 max-w-[200px] truncate">{payment.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="lg:hidden space-y-2">
        {payments.map(payment => (
          <MobileRecordCard
            key={payment.id}
            title={formatTRY(payment.amount || 0)}
            subtitle={payment.payment_date ? new Date(payment.payment_date).toLocaleDateString('tr-TR') : ''}
            rows={[
              { label: 'Satış No', value: payment.sale_no || '—' },
              { label: 'Yöntem', value: payment.payment_method || '—' },
              ...(payment.receipt_no ? [{ label: 'Makbuz No', value: payment.receipt_no }] : []),
              ...(payment.description ? [{ label: 'Açıklama', value: payment.description }] : []),
            ]}
          />
        ))}
      </div>
    </div>
  );
}